export default "__VITE_ASSET__POzGEKde__"